// removed by extract-text-webpack-plugin
module.exports = {"wait-time":"ServiceWaitingRoom__wait-time___2B_Om"};